<template>
    <div class="w-[100vw] h-[100vh] fixed top-0 left-0 flex justify-center items-center bg-[#0000005a]">
        <div class=" w-[50%] h-[60%]">
            <AppGenericCrud
                v-if="show_crud"
                :model="crud.crud_model"
                :data="{
                    title: title,
                    dependency: false,
                    entity_type: crud.crud_type,
                    key_name: crud.crud_type + '_id',
                    rotas: crud.rotas,
                    owner: owner,
                }"
                :types="crud.types"
                :set_data="crud.crud_set_data"
                :set_id="crud.crud_set_id"
                :with_address="crud.with_address"
                save_and_return="true"
                @close="close_crud"
                @save_entity="set_entity"
            />
        </div>
    </div>
</template>

<script>
import AppButton from "@/components/updated/button.vue";
import AppGenericCrud from '@/components/genericSetCRUD.vue';
import axios from 'axios';
import { id as loggedID } from '@/extraData';
export default {
    name: 'crudPopUp',
    components: {
        AppButton,
        AppGenericCrud
    },
    props: {
        title: {
            type: String,
            default: 'Título'
        },
        crud_data: {
            type: Object,
            default: () => ({})
        },
    },
    data() {
        return {
            show_crud: false,
            baseURl: process.env.VUE_APP_URL_BASE,
            crud: {
                crud_title: '',
                crud_type: '',
                crud_model: {},
                crud_set_data: {},
                crud_set_id: {},
                crud_types: {},
                crud_multiTable: false,
                with_address: false,
            },
            owner: null,
            types: [],
            current_entity: {}
        }
    },
    async created() {
        await this.get_types();
        this.setCrudType();
    },
    methods: {
        async select_all(url) {
            try {
                const res = await axios.get(url);
                return res.data.data;
            } catch (error) {
                console.error('Error getting data:', error);
            }
        },
        async get_types() {
            const types = await this.select_all(`${this.baseURl}/api/v1/tp${this.crud_data.type}/`);
            this.types = types?.sort((a, b) => a.id - b.id);
        },
        close_crud() {
            this.show_crud = false;
            this.$emit('close');
        },
        setCrudType() {
            if (this.crud_data.owner && this.crud_data.owner.id && this.crud_data.owner.name) {
                this.crud_type = `${this.crud_data.owner.name}/${this.crud_data.owner.id}/${this.crud_data.type}/`;
            } else {
                this.crud_type = `${this.crud_data.type}/`;
            }
            if (this.crud_data['type'] === 'contacto') {
                this.crud.crud_model = this.crud_data.model;
                this.crud.crud_type = this.crud_data.type;
                this.crud.types = {
                    tipo: this.types
                };
                this.crud.crud_set_data = {
                    tipo: { id: 0, nome: 'N/A' }
                };
                this.crud.crud_set_id = {
                    tipo: this.crud_data.set_id.tipo
                };
                this.crud.crud_multiTable = this.crud_data.multiTable;
                this.crud.with_address = false;
                this.crud.rotas = {
                    create_url: `${this.baseURl}/api/v1/${this.crud.crud_type}/registrar/`,
                    select_all_url: (this.crud_data.owner && this.crud_data.owner.name && this.crud_data.owner.id)
                        ? `${this.baseURl}/api/v1/${this.crud_data.owner.name}/${this.crud_data.owner.id}/?${this.crud.crud_type}_only=true`
                        : `${this.baseURl}/api/v1/${this.crud.crud_type}/`,
                    select_url: `${this.baseURl}/api/v1/${this.crud.crud_type}/`,
                    update_url: `${this.baseURl}/api/v1/${this.crud.crud_type}/editar`,
                    delete_url: `${this.baseURl}/api/v1/${this.crud.crud_type}/eliminar`
                };
                if (this.crud_data.owner && this.crud_data.owner.id && this.crud_data.owner.name) {
                    this.owner = {
                        id: this.crud_data.owner.id,
                        key_name: `${this.crud_data.owner.name}_id`,
                        type: this.crud_data.owner.name,
                        multiTable: this.crud.crud_multiTable,
                        rotas: {
                            create_url: `${this.baseURl}/api/v1/${this.crud_data.owner.name}_${this.crud.crud_type}/registrar/`
                        }
                    };
                } else {
                    this.owner = null;
                }
                this.show_crud = true;
            }
        },
        set_entity(entity) {
            this.current_entity = JSON.parse(JSON.stringify(entity));
            this.$emit('set_entity', entity);
        }
    },
    watch: {
        crud_data: {
            handler: function (newVal) {
                this.crud_data = newVal;
                this.setCrudType();
            },
            deep: true
        }
    }
}
</script>

<style scoped></style>
